/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import theme from '@salesforce/retail-react-app/app/components/shared/theme';

/**
 * App theme styles
 *
 * Note: headerWrapper position is kept as 'sticky' for now.
 * The header component handles its own background/color styling via useHeaderContext.
 * Future enhancement: make headerWrapper position dynamic based on header state.
 */
export default {
  baseStyle: {
    container: {
      backgroundColor: 'brandColors.primaryBG',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minWidth: '345px',
    },
    headerWrapper: {
      position: 'sticky',
      top: 0,
      zIndex: theme.zIndices.sticky,
    },
  },
  parts: ['container', 'headerWrapper'],
};
